//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    offset: {
      type: Number,
      default: 40
    },
    divTop:{
      type: String,
      default: '0px'
    },
    loadingText: {
      type: String,
      default: '加载中...'
    },
    divBottom:{
      type: String,
      default: '0px'
    },
    enableInfinite: {
      type: Boolean,
      default: true
    },
    enableRefresh: {
      type: Boolean,
      default: true
    },
    onRefresh: {
      type: Function,
      default: undefined,
      required: false
    },
    onInfinite: {
      type: Function,
      default: undefined,
      require: false
    }
  },
  data() {
    return {
      top: 0,
      state: 0,
      startY: 0,
      touching: false,
      infiniteLoading: false,
      scrollback:false
    }
  },
  watch:{
  },
  methods: {
    touchStart(e) {
      this.startY = e.targetTouches[0].pageY
      this.startScroll = this.$el.scrollTop || 0
      this.touching = true

    },
    touchMove(e) {

      if (!this.enableRefresh || this.$el.scrollTop > 0 || !this.touching) {
        return
      }
      let diff = e.targetTouches[0].pageY - this.startY - this.startScroll
      if (diff > 0) e.preventDefault()
      this.top = Math.pow(diff, 0.8) + (this.state === 2 ? this.offset : 0)

      if (this.state === 2) { // in refreshing
        return
      }
      if (this.top >= this.offset) {
        this.state = 1
      } else {
        this.state = 0
      }
    },
    touchEnd(e) {

      if (!this.enableRefresh) return

      this.touching = false
      if (this.state === 2) { // in refreshing
        this.state = 2
        this.top = this.offset
        return
      }
      if (this.top >= this.offset) { // do refresh
        this.refresh()
      } else { // cancel refresh
        this.state = 0
        this.top = 0
      }
    },
    refresh() {
      this.state = 2
      this.top = this.offset
      this.onRefresh(this.refreshDone)
   /*   console.log(this.offset)*/
    },
    refreshDone() {
      this.state = 0
      this.top = 0
      this.infiniteLoading = false
    },

    infinite() {
      this.infiniteLoading = true
      this.onInfinite(this.infiniteDone)
    },

    infiniteDone() {
      this.infiniteLoading = false
    },
    scrollbackClick(){
      this.$refs.yoScroll.scrollTop =0;
      this.scrollback = false;
    },
    onScroll(e) {

      if (!this.enableInfinite || this.infiniteLoading) {
        return
      }

      let outerHeight = this.$el.clientHeight
      let innerHeight = this.$el.querySelector('.inner').clientHeight
      let scrollTop = this.$el.scrollTop
      if(scrollTop>1100){
        this.scrollback = true;
      }else if(scrollTop<100){
        this.scrollback = false;
      }
      let ptrHeight = this.onRefresh ? this.$el.querySelector('.pull-refresh').clientHeight : 0
      let infiniteHeight = this.$el.querySelector('.load-more').clientHeight
      let bottom = innerHeight - outerHeight - scrollTop - ptrHeight;
      if (parseInt(bottom) == 0){
        this.infinite();
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/pull-refresh.vue